/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { h as helper } from '../_chunks/dep-115a1bd3.js';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, getCurrentInstance, ref, toRefs, computed, nextTick, watch, provide } from '@vue/composition-api';
import isFunction from 'lodash/isFunction';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import useDefaultValue from '../hooks/useDefaultValue.js';
import useVModel from '../hooks/useVModel.js';
import { useTNodeJSX } from '../hooks/tnode.js';
import { useConfig, usePrefixClass } from '../config-provider/useConfig.js';
import props from './props.js';
import { Loading } from '../loading/index.js';
import { Popup } from '../popup/index.js';
import { Input } from '../input/index.js';
import { Tag } from '../tag/index.js';
import { SelectInput } from '../select-input/index.js';
import FakeArrow from '../common-components/fake-arrow.js';
import _Option from './option.js';
import SelectPanel from './select-panel.js';
import { getSingleContent, getMultipleContent, getNewMultipleValue } from './util.js';
import useSelectOptions from './hooks/useSelectOptions.js';
import 'lodash/isEmpty';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../hooks/render-tnode.js';
import 'lodash/isString';
import 'lodash/isObject';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../config-provider/config-receiver.js';
import 'vue';
import '../utils/mixins.js';
import '../utils/dom.js';
import 'raf';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../loading/type.js';
import '../loading/plugin.js';
import '../config.js';
import '../popup/popup.js';
import '@popperjs/core';
import '../utils/helper.js';
import '../popup/props.js';
import '../popup/container.js';
import '../utils/map-props.js';
import '../popup/type.js';
import '../input/input.js';
import 'tdesign-icons-vue';
import '../utils/event.js';
import '../input/props.js';
import '../input/input-group.js';
import '../input/type.js';
import '../tag/tag.js';
import '../tag/props.js';
import '../tag/check-tag.js';
import '../tag/check-tag-props.js';
import '../tag/type.js';
import '../select-input/select-input.js';
import '../select-input/props.js';
import '../select-input/useSingle.js';
import 'lodash/pick';
import '../hooks/useConfig.js';
import '../select-input/useMultiple.js';
import '../tag-input/index.js';
import '../tag-input/tag-input.js';
import '../tag-input/props.js';
import '../tag-input/hooks/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag-input/hooks/useHover.js';
import '../tag-input/hooks/useDragSorter.js';
import '../hooks/useGlobalIcon.js';
import '../tag-input/type.js';
import '../select-input/useOverlayInnerStyle.js';
import '../select-input/type.js';
import '../utils/ripple.js';
import './option-props.js';
import '../checkbox/index.js';
import '../checkbox/group.js';
import 'lodash/intersection';
import '../checkbox/checkbox.js';
import '../checkbox/props.js';
import '../checkbox/checkbox-group-props.js';
import '../checkbox/type.js';
import '../hooks/useLazyLoad.js';
import '../_common/js/utils/observe.js';
import '../hooks/useCommonClassName.js';
import '../hooks/useVirtualScroll.js';

var _excluded = ["overlayClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TSelect = defineComponent({
  name: "TSelect",
  props: _objectSpread({}, props),
  components: {
    TInput: Input,
    TLoading: Loading,
    Tag: Tag,
    Popup: Popup,
    TOption: _Option,
    FakeArrow: FakeArrow,
    SelectPanel: SelectPanel
  },
  setup: function setup(props2, context) {
    var _useConfig = useConfig("select"),
        t = _useConfig.t,
        global = _useConfig.global;

    var renderTNode = useTNodeJSX();
    var instance = getCurrentInstance();
    var selectInputRef = ref(null);
    var popupOpenTime = ref(250);
    var formDisabled = ref();
    var COMPONENT_NAME = usePrefixClass("select");

    var _useConfig2 = useConfig("classPrefix"),
        classPrefix = _useConfig2.classPrefix;

    var _toRefs = toRefs(props2),
        valueType = _toRefs.valueType,
        disabled = _toRefs.disabled,
        size = _toRefs.size,
        valueProps = _toRefs.value,
        multiple = _toRefs.multiple,
        placeholder = _toRefs.placeholder,
        loading = _toRefs.loading,
        max = _toRefs.max,
        reserveKeyword = _toRefs.reserveKeyword,
        inputValue = _toRefs.inputValue,
        popupVisible = _toRefs.popupVisible,
        minCollapsedNum = _toRefs.minCollapsedNum;

    var keys = computed(function () {
      var _props2$keys, _props2$keys2;

      return {
        label: ((_props2$keys = props2.keys) === null || _props2$keys === void 0 ? void 0 : _props2$keys.label) || "label",
        value: ((_props2$keys2 = props2.keys) === null || _props2$keys2 === void 0 ? void 0 : _props2$keys2.value) || "value"
      };
    });

    var _useSelectOptions = useSelectOptions(props2, instance, keys),
        innerOptions = _useSelectOptions.options,
        optionsMap = _useSelectOptions.optionsMap,
        optionsList = _useSelectOptions.optionsList;

    var _useVModel = useVModel(valueProps, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        value = _useVModel2[0],
        setValue = _useVModel2[1];

    var innerValue = computed(function () {
      if (valueType.value === "object") {
        return multiple.value ? value.value.map(function (option) {
          return option[keys.value.value];
        }) : value.value[keys.value.value];
      }

      return value.value;
    });

    var setInnerValue = function setInnerValue(newVal, e) {
      if (valueType.value === "object") {
        var _keys$value = keys.value,
            valueOfKeys = _keys$value.value,
            labelOfKeys = _keys$value.label;
        var oldValueMap = /* @__PURE__ */new Map();

        if (multiple.value) {
          value.value.forEach(function (option) {
            oldValueMap.set(option[valueOfKeys], option);
          });
        }

        var getOption = function getOption(val) {
          var _ref;

          var option = optionsMap.value.get(val) || oldValueMap.get(val);
          return _ref = {}, _defineProperty(_ref, valueOfKeys, get(option, valueOfKeys)), _defineProperty(_ref, labelOfKeys, get(option, labelOfKeys)), _ref;
        };

        newVal = multiple.value ? newVal.map(function (val) {
          return getOption(val);
        }) : getOption(newVal);
      }

      if (newVal === value.value) return;
      setValue(newVal, e);
    };

    var _useDefaultValue = useDefaultValue(inputValue, props2.defaultInputValue || "", props2.onInputChange, "inputValue", "input-change"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        tInputValue = _useDefaultValue2[0],
        setTInputValue = _useDefaultValue2[1];

    var _useDefaultValue3 = useDefaultValue(popupVisible, false, function (visible, context2) {
      var _props2$onPopupVisibl, _props2$onVisibleChan;

      (_props2$onPopupVisibl = props2.onPopupVisibleChange) === null || _props2$onPopupVisibl === void 0 ? void 0 : _props2$onPopupVisibl.call(props2, visible, context2);
      (_props2$onVisibleChan = props2.onVisibleChange) === null || _props2$onVisibleChan === void 0 ? void 0 : _props2$onVisibleChan.call(props2, visible);
      instance.emit("visible-change", visible);
    }, "popupVisible", "popup-visible-change"),
        _useDefaultValue4 = _slicedToArray(_useDefaultValue3, 2),
        innerPopupVisible = _useDefaultValue4[0],
        setInnerPopupVisible = _useDefaultValue4[1];

    var isDisabled = computed(function () {
      return formDisabled.value || disabled.value;
    });
    var isLoading = computed(function () {
      return loading.value && !isDisabled.value;
    });
    var isFilterable = computed(function () {
      return Boolean(props2.filterable || global.value.filterable || isFunction(props2.filter));
    });
    var isReachMaxLimit = computed(function () {
      return multiple.value && max.value !== 0 && max.value <= innerValue.value.length;
    });
    var placeholderText = computed(function () {
      var _ref2;

      return (_ref2 = !multiple.value && innerPopupVisible.value && (valueType.value === "object" && value.value[keys.value.label] || getSingleContent(innerValue.value, optionsList.value)) || placeholder.value) !== null && _ref2 !== void 0 ? _ref2 : t(global.value.placeholder);
    });
    var displayText = computed(function () {
      if (multiple.value) {
        if (valueType.value === "object") {
          return value.value.map(function (v) {
            return v[keys.value.label];
          });
        }

        return getMultipleContent(innerValue.value, optionsList.value);
      }

      if (valueType.value === "object" && value.value[keys.value.label]) {
        return value.value[keys.value.label];
      }

      return getSingleContent(innerValue.value, optionsList.value);
    });
    var valueDisplayParams = computed(function () {
      var val = multiple.value ? innerValue.value.map(function (value2) {
        var _optionsMap$value$get;

        return {
          value: value2,
          label: (_optionsMap$value$get = optionsMap.value.get(value2)) === null || _optionsMap$value$get === void 0 ? void 0 : _optionsMap$value$get.label
        };
      }) : innerValue.value;
      return {
        value: val,
        onClose: multiple.value ? function (index) {
          return removeTag(index);
        } : function () {}
      };
    });
    var collapsedItemsParams = computed(function () {
      return multiple.value ? {
        value: innerValue.value,
        collapsedSelectedItems: innerValue.value.slice(minCollapsedNum.value),
        count: innerValue.value.length - minCollapsedNum.value
      } : {};
    });

    var removeTag = function removeTag(index, context2) {
      var _props2$onRemove;

      var _ref3 = context2 || {},
          e = _ref3.e;

      e === null || e === void 0 ? void 0 : e.stopPropagation();

      if (isDisabled.value) {
        return;
      }

      var selectValue = cloneDeep(innerValue.value);
      var value2 = selectValue[index];
      selectValue.splice(index, 1);
      setInnerValue(selectValue, {
        e: e,
        trigger: "tag-remove"
      });
      var evtObj = {
        value: value2,
        data: optionsMap.value.get(value2),
        e: e
      };
      instance.emit("remove", evtObj);
      (_props2$onRemove = props2.onRemove) === null || _props2$onRemove === void 0 ? void 0 : _props2$onRemove.call(props2, evtObj);
    };

    var handleCreate = function handleCreate() {
      var _props2$onCreate;

      if (!tInputValue.value) return;
      var createVal = tInputValue.value;
      setTInputValue("");
      instance.emit("create", createVal);
      (_props2$onCreate = props2.onCreate) === null || _props2$onCreate === void 0 ? void 0 : _props2$onCreate.call(props2, createVal);
    };

    var handleClear = function handleClear(_ref4) {
      var _props2$onClear;

      var e = _ref4.e;
      e === null || e === void 0 ? void 0 : e.stopPropagation();

      if (multiple.value) {
        setInnerValue([], {
          trigger: "clear",
          e: e
        });
      } else {
        setInnerValue("", {
          trigger: "clear",
          e: e
        });
      }

      instance.emit("clear", {
        e: e
      });
      (_props2$onClear = props2.onClear) === null || _props2$onClear === void 0 ? void 0 : _props2$onClear.call(props2, {
        e: e
      });
    };

    var handleTInputValueChange = function handleTInputValueChange(val, context2) {
      if (context2.trigger === "blur" || !innerPopupVisible.value) return;
      setTInputValue(val);
      debounceSearch();
    };

    var handleTagChange = function handleTagChange(currentTags, context2) {
      var trigger = context2.trigger,
          index = context2.index,
          e = context2.e;

      if (trigger === "clear") {
        setInnerValue([], {
          trigger: "tag-remove",
          e: e
        });
      }

      if (["tag-remove", "backspace"].includes(trigger)) {
        removeTag(index);
      }
    };

    var handleFocus = function handleFocus(value2, context2) {
      var _props2$onFocus;

      instance.emit("focus", {
        value: value2,
        e: context2 === null || context2 === void 0 ? void 0 : context2.e
      });
      (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 ? void 0 : _props2$onFocus.call(props2, {
        value: value2,
        e: context2 === null || context2 === void 0 ? void 0 : context2.e
      });
    };

    var handleBlur = function handleBlur(value2, context2) {
      var _props2$onBlur;

      instance.emit("blur", {
        value: value2,
        e: context2 === null || context2 === void 0 ? void 0 : context2.e
      });
      (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 ? void 0 : _props2$onBlur.call(props2, {
        value: value2,
        e: context2 === null || context2 === void 0 ? void 0 : context2.e
      });
    };

    var handleEnter = function handleEnter(value2, context2) {
      var _props2$onEnter;

      instance.emit("enter", {
        value: value2,
        e: context2 === null || context2 === void 0 ? void 0 : context2.e,
        inputValue: tInputValue.value
      });
      (_props2$onEnter = props2.onEnter) === null || _props2$onEnter === void 0 ? void 0 : _props2$onEnter.call(props2, {
        value: value2,
        e: context2 === null || context2 === void 0 ? void 0 : context2.e,
        inputValue: tInputValue.value.toString()
      });
      handleCreate();
    };

    var debounceSearch = debounce(function () {
      var _props2$onSearch;

      instance.emit("search", tInputValue.value);
      (_props2$onSearch = props2.onSearch) === null || _props2$onSearch === void 0 ? void 0 : _props2$onSearch.call(props2, tInputValue.value.toString());
    }, 300);

    var getOverlayElm = function getOverlayElm() {
      var r;

      try {
        var popupRefs = context.refs.selectInputRef.$refs.selectInputRef.$refs;
        r = popupRefs.overlay || popupRefs.component.$refs.overlay;
      } catch (e) {
        console.warn("TDesign Warn:", e);
      }

      return r;
    };

    var updateScrollTop = function updateScrollTop(content) {
      var _props2$scroll;

      if (((_props2$scroll = props2.scroll) === null || _props2$scroll === void 0 ? void 0 : _props2$scroll.type) === "virtual") return;
      var overlayEl = getOverlayElm();
      if (!overlayEl) return;
      var firstSelectedNode = overlayEl === null || overlayEl === void 0 ? void 0 : overlayEl.querySelector(".".concat(classPrefix.value, "-is-selected"));
      nextTick(function () {
        if (firstSelectedNode && content) {
          var _getComputedStyle = getComputedStyle(firstSelectedNode),
              paddingBottom = _getComputedStyle.paddingBottom;

          var _getComputedStyle2 = getComputedStyle(content),
              marginBottom = _getComputedStyle2.marginBottom;

          var elementBottomHeight = parseInt(paddingBottom, 10) + parseInt(marginBottom, 10);
          var updateValue = firstSelectedNode.offsetTop - content.offsetTop - (content.clientHeight - firstSelectedNode.clientHeight) + elementBottomHeight;
          content.scrollTop = updateValue;
        }
      });
    };

    var hoverIndex = ref(-1);

    var keydownEvent = function keydownEvent(e) {
      var optionsListLength = optionsList.value.length;

      var arrowDownOption = function arrowDownOption() {
        var count = 0;

        while (hoverIndex.value < optionsListLength) {
          var _optionsList$value$ho;

          if (!((_optionsList$value$ho = optionsList.value[hoverIndex.value]) !== null && _optionsList$value$ho !== void 0 && _optionsList$value$ho.disabled)) {
            break;
          }

          if (hoverIndex.value === optionsListLength - 1) {
            hoverIndex.value = 0;
          } else {
            hoverIndex.value += 1;
          }

          count += 1;
          if (count >= optionsListLength) break;
        }
      };

      var arrowUpOption = function arrowUpOption() {
        var count = 0;

        while (hoverIndex.value > -1) {
          var _optionsList$value$ho2;

          if (!((_optionsList$value$ho2 = optionsList.value[hoverIndex.value]) !== null && _optionsList$value$ho2 !== void 0 && _optionsList$value$ho2.disabled)) {
            break;
          }

          if (hoverIndex.value === 0) {
            hoverIndex.value = optionsListLength - 1;
          } else {
            hoverIndex.value -= 1;
          }

          count += 1;
          if (count >= optionsListLength) break;
        }
      };

      if (optionsListLength === 0) return;
      var preventKeys = ["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"];

      if (preventKeys.includes(e.code)) {
        e.preventDefault();
      }

      switch (e.code) {
        case "ArrowDown":
          if (hoverIndex.value === -1) {
            hoverIndex.value = 0;
            return;
          }

          if (hoverIndex.value < optionsListLength - 1) {
            hoverIndex.value += 1;
            arrowDownOption();
          } else {
            hoverIndex.value = 0;
            arrowDownOption();
          }

          break;

        case "ArrowUp":
          if (hoverIndex.value === -1) {
            hoverIndex.value = 0;
            return;
          }

          if (hoverIndex.value > 0) {
            hoverIndex.value -= 1;
            arrowUpOption();
          } else {
            hoverIndex.value = optionsListLength - 1;
            arrowUpOption();
          }

          break;

        case "Enter":
          if (hoverIndex.value === -1) return;

          if (!multiple.value) {
            setInnerValue(optionsList.value[hoverIndex.value].value, {
              e: e,
              trigger: "check"
            });
            setInnerPopupVisible(false, {
              e: e
            });
          } else {
            var _optionsList$value$ho3;

            if (hoverIndex.value === -1) return;
            var optionValue = (_optionsList$value$ho3 = optionsList.value[hoverIndex.value]) === null || _optionsList$value$ho3 === void 0 ? void 0 : _optionsList$value$ho3.value;
            if (!optionValue) return;
            var newValue = getNewMultipleValue(innerValue.value, optionValue);
            setInnerValue(newValue.value, {
              e: e,
              trigger: newValue.isCheck ? "check" : "uncheck"
            });
          }

          break;

        case "Escape":
        case "Tab":
          setInnerPopupVisible(false, {
            trigger: "keydown-esc",
            e: e
          });
          setTInputValue("");
          break;
      }
    };

    var checkValueInvalid = function checkValueInvalid() {
      if (!multiple.value && isArray(value.value)) {
        value.value = "";
      }

      if (multiple.value && !isArray(value.value)) {
        value.value = [];
      }
    };

    watch(value, function () {
      checkValueInvalid();
    }, {
      immediate: true
    });
    watch(innerPopupVisible, function (val) {
      val && document.addEventListener("keydown", keydownEvent);
      !val && document.removeEventListener("keydown", keydownEvent);
    }, {
      flush: "sync"
    });
    watch(innerPopupVisible, function (value2) {
      if (value2) {
        hoverIndex.value = -1;
      } else {
        tInputValue.value && setTInputValue("");
      }
    });
    provide("tSelect", {
      size: size,
      multiple: multiple,
      popupOpenTime: popupOpenTime,
      hoverIndex: hoverIndex,
      selectValue: innerValue,
      reserveKeyword: reserveKeyword,
      isReachMaxLimit: isReachMaxLimit,
      getOverlayElm: getOverlayElm,
      handleCreate: handleCreate,
      handleValueChange: setInnerValue,
      handlerInputChange: setTInputValue,
      handlePopupVisibleChange: setInnerPopupVisible
    });
    return {
      isFilterable: isFilterable,
      isDisabled: isDisabled,
      isLoading: isLoading,
      innerOptions: innerOptions,
      placeholderText: placeholderText,
      selectInputRef: selectInputRef,
      innerPopupVisible: innerPopupVisible,
      displayText: displayText,
      tInputValue: tInputValue,
      collapsedItemsParams: collapsedItemsParams,
      valueDisplayParams: valueDisplayParams,
      handleFocus: handleFocus,
      handleBlur: handleBlur,
      handleEnter: handleEnter,
      handleClear: handleClear,
      handleTagChange: handleTagChange,
      handleTInputValueChange: handleTInputValueChange,
      setInnerPopupVisible: setInnerPopupVisible,
      removeTag: removeTag,
      renderTNode: renderTNode,
      updateScrollTop: updateScrollTop,
      componentName: COMPONENT_NAME
    };
  },
  methods: {
    renderSuffixIcon: function renderSuffixIcon() {
      var h = this.$createElement;
      var isLoading = this.isLoading,
          showArrow = this.showArrow,
          innerPopupVisible = this.innerPopupVisible,
          isDisabled = this.isDisabled;

      if (isLoading) {
        return h("t-loading", {
          "class": ["".concat(this.componentName, "__right-icon"), "".concat(this.componentName, "__active-icon")],
          "attrs": {
            "size": "small"
          }
        });
      }

      return showArrow ? h("fake-arrow", {
        "attrs": {
          "overlayClassName": "".concat(this.componentName, "__right-icon"),
          "isActive": innerPopupVisible && !isDisabled
        }
      }) : null;
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var renderTNode = this.renderTNode;

    var prefixIcon = function prefixIcon() {
      return renderTNode("prefixIcon");
    };

    var valueDisplay = function valueDisplay() {
      return renderTNode("valueDisplay", {
        params: _this.valueDisplayParams
      });
    };

    var collapsedItems = function collapsedItems() {
      return renderTNode("collapsedItems", {
        params: _this.collapsedItemsParams
      });
    };

    var _ref5 = this.popupProps || {},
        overlayClassName = _ref5.overlayClassName,
        restPopupProps = _objectWithoutProperties(_ref5, _excluded);

    return h("div", {
      "ref": "select",
      "class": "".concat(this.componentName, "__wrap")
    }, [h(SelectInput, helper([{
      "ref": "selectInputRef",
      "class": this.componentName,
      "attrs": {
        "autoWidth": this.autoWidth,
        "borderless": this.borderless || !this.bordered,
        "readonly": this.readonly,
        "allowInput": this.isFilterable,
        "multiple": this.multiple,
        "keys": this.keys,
        "status": this.status,
        "tips": this.tips,
        "value": this.displayText,
        "valueDisplay": valueDisplay,
        "clearable": this.clearable,
        "disabled": this.isDisabled,
        "label": prefixIcon,
        "suffixIcon": this.renderSuffixIcon,
        "placeholder": this.placeholderText,
        "inputValue": this.tInputValue,
        "inputProps": _objectSpread({
          size: this.size
        }, this.inputProps),
        "tagInputProps": _objectSpread({
          autoWidth: true
        }, this.tagInputProps),
        "tagProps": this.tagProps,
        "minCollapsedNum": this.minCollapsedNum,
        "collapsedItems": collapsedItems,
        "popupVisible": this.innerPopupVisible,
        "popupProps": _objectSpread({
          overlayClassName: ["".concat(this.componentName, "__dropdown"), overlayClassName]
        }, restPopupProps)
      }
    }, {
      "on": {
        focus: this.handleFocus,
        blur: this.handleBlur,
        enter: this.handleEnter,
        clear: this.handleClear,
        "input-change": this.handleTInputValueChange,
        "popup-visible-change": this.setInnerPopupVisible,
        "tag-change": this.handleTagChange
      }
    }, {}, this.selectInputProps, {
      "attrs": {
        "updateScrollTop": this.updateScrollTop
      }
    }]), [h("select-panel", {
      "slot": "panel",
      "scopedSlots": this.$scopedSlots,
      "attrs": {
        "size": this.size,
        "options": this.innerOptions,
        "inputValue": this.tInputValue,
        "multiple": this.multiple,
        "empty": this.empty,
        "filter": this.filter,
        "filterable": this.isFilterable,
        "creatable": this.creatable,
        "scroll": this.scroll,
        "loading": this.isLoading,
        "loadingText": this.loadingText,
        "panelTopContent": this.panelTopContent,
        "panelBottomContent": this.panelBottomContent
      }
    })])]);
  }
});

export { TSelect as default };
//# sourceMappingURL=select.js.map
